import { render, staticRenderFns } from "./SmarttTenderNotifications.vue?vue&type=template&id=13066171&scoped=true"
import script from "./SmarttTenderNotifications.vue?vue&type=script&lang=js"
export * from "./SmarttTenderNotifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13066171",
  null
  
)

export default component.exports